import React from "react";
import { Routes, Route, NavLink, useLocation } from "react-router-dom";
import Dashboard from "../component/dashboard/dashboard";
import Transaction from "../component/transaction/transaction";
import { LuDot } from "react-icons/lu";
import UserId from "../component/userId";

const Home = () => {
  const location = useLocation();
  const isDashboardActive = location.pathname.startsWith("/home/dashboard");
  const isTransactionActive = location.pathname.startsWith("/home/transaction");

  return (
    <div className="">
      <div className="border-b">
        <div className="container flex justify-between items-center py-8">
          <h2 className="text-4xl max-sm:text-3xl font-semibold uppercase ">
            Logo
          </h2>

          <div className="text-lg w-72 max-md:w-auto flex justify-between max-md:gap-5 max-sm:hidden">
            <NavLink
              to="dashboard/sale"
              className={`${
                isDashboardActive ? "font-medium" : "font-normal text-gray-500"
              } cursor-pointer flex flex-col justify-center relative`}
            >
              Dashboard
              <div className="flex justify-center items-center">
                <LuDot
                  className="text-3xl absolute -bottom-5"
                  style={{ display: isDashboardActive ? "block" : "none" }} // Display dot if active
                />
              </div>
            </NavLink>

            <NavLink
              to="transaction/sale"
              className={`
                ${
                  isTransactionActive
                    ? "font-medium"
                    : "font-normal text-gray-500"
                }  cursor-pointer flex flex-col justify-center relative`}
            >
              New Transaction
              <div className="flex justify-center items-center">
                <LuDot
                  className="text-3xl absolute -bottom-5"
                  style={{ display: isTransactionActive ? "block" : "none" }} // Display dot if active
                />
              </div>
            </NavLink>
          </div>

          <UserId />
        </div>
      </div>

      <div className="container">
        <div className="text-lg mt-3 max-md:w-60 flex justify-between sm:hidden">
          <NavLink
            to="dashboard/sale"
            className={`${
              isDashboardActive
                ? "font-medium text-primary"
                : "font-normal text-gray-400"
            } cursor-pointer flex flex-col justify-center relative`}
          >
            Dashboard
            <div className="flex justify-center items-center">
              <LuDot
                className={`text-3xl absolute -bottom-5 ${
                  isDashboardActive ? "block" : "hidden"
                }`}
              />
            </div>
          </NavLink>

          <NavLink
            to="transaction/sale"
            className={`${
              isTransactionActive
                ? "font-medium text-primary"
                : "font-normal text-gray-400"
            } cursor-pointer flex flex-col justify-center relative`}
          >
            New Transaction
            <div className="flex justify-center items-center">
              <LuDot
                className={`text-3xl absolute -bottom-5 ${
                  isTransactionActive ? "block" : "hidden"
                }`}
              />
            </div>
          </NavLink>
        </div>

        <Routes>
          <Route path="dashboard/*" element={<Dashboard />} />
          <Route path="transaction/*" element={<Transaction />} />
        </Routes>
      </div>
    </div>
  );
};

export default Home;
